import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-rounded',
  templateUrl: './button-rounded.component.html',
})
export class ButtonRoundedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
